import CompanyInfoPanel from './companyInfoPanel.container';

export default CompanyInfoPanel